import { styled } from 'linaria/react';
import { COLORS, FONTS } from 'styles/constants';

export const StyledFloatingMenuContainer = styled.div<{ isVisible: boolean; isSparksTabActive?: boolean }>`
  position: fixed;
  margin-left: ${({ isSparksTabActive }) => (isSparksTabActive === true ? '25px' : '0')};
  bottom: ${({ isVisible }) => (isVisible ? 'calc(34px + 58px + 12px)' : 'calc(34px + 58px - 10px)')};
  left: 50%;
  transform: translateX(-50%);
  z-index: 200;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? 'all' : 'none')};
  transition: opacity 0.4s cubic-bezier(0, 0, 0, 1), bottom 0.4s cubic-bezier(0, 0, 0, 1), margin-left 0.3s ease-out;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledFloatingMenu = styled.div`
  display: inline-flex;
  padding: 4px;
  align-items: flex-start;
  gap: 2px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(30px);
  box-shadow: 0px 0px 2px 0px rgba(255, 255, 255, 1) inset;
  transition: background 0.3s ease, box-shadow 0.3s ease;
`;

export const StyledFloatingButton = styled.button<{ isActive: boolean }>`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 22px;
  border: none;
  cursor: pointer;
  background: ${({ isActive }) => (isActive ? COLORS.brown.dark[100] : 'transparent')};
  transition: background 0.2s ease;

  & svg {
    width: 24px;
    height: 24px;
  }

  & path,
  & line,
  & circle,
  & rect {
    stroke: ${({ isActive }) => (isActive ? COLORS.white[100] : COLORS.brown.dark[100])};
    transition: stroke 0.2s ease;
  }
`;

// Spark creation button - standalone circular button
export const StyledSparkCreationButton = styled.button`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(30px);
  box-shadow: 0px 0px 2px 0px rgba(255, 255, 255, 1) inset;
  transition: transform 0.2s ease;

  &:active {
    transform: scale(0.95);
  }

  & video {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

// Text-based tab button for Discovery pages
export const StyledTabButton = styled.button<{ isActive: boolean }>`
  display: flex;
  height: 24px;
  padding: ${({ isActive }) => (isActive ? '2px 12px' : '4px 12px')};
  flex-direction: ${({ isActive }) => (isActive ? 'column' : 'row')};
  justify-content: center;
  align-items: center;
  gap: ${({ isActive }) => (isActive ? '2px' : '10px')};
  border: none;
  cursor: pointer;
  border-radius: ${({ isActive }) => (isActive ? '999px' : '0')};
  background: ${({ isActive }) => (isActive ? 'rgba(255, 255, 255, 0.60)' : 'transparent')};
  transition: background 0.2s ease, border-radius 0.2s ease;

  color: ${({ isActive }) => (isActive ? COLORS.brown.dark[100] : 'rgba(24, 24, 0, 0.60)')};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: ${FONTS.secondary};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
`;
